import { render, staticRenderFns } from "./BoardList.vue?vue&type=template&id=5287b7cf&"
import script from "./BoardList.vue?vue&type=script&lang=js&"
export * from "./BoardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports